export default {
  title: 'Approval inbox',
  subtitle: 'Support actions proposed from HubSpot',

  lanes: {
    READY_TO_APPROVE: 'Ready to approve',
    NEEDS_DECISION: 'Needs a decision',
    MANUAL: 'Manual',
  },

  review: {
    tab_label: 'Executed with warning',
  },

  filters: {
    action_type: 'Action type',
    all_action_types: 'All types',
    school_id: 'School ID',
    date_from: 'From',
    date_to: 'To',
    search: 'Search',
    clear: 'Clear filters',
  },

  action_types: {
    ENROLLMENT_WITHDRAW: 'Enrollment withdrawal',
    ENROLLMENT_CHANGE_COURSE: 'Course change',
    ENROLLMENT_CHANGE_CAMPUS: 'Campus change',
    STUDENT_FIX_PERSONAL_DATA: 'Personal data fix',
    STUDENT_FIX_EMAIL: 'Student email fix',
    PARENT_FIX_EMAIL: 'Parent email fix',
    STUDENT_FIX_DNI: 'DNI fix',
    TEACHER_CREATE: 'Teacher creation',
    TEACHER_REASSIGN_COURSE: 'Teacher course reassignment',
    SIBLINGS_CROSSED_RECORDS: 'Crossed sibling records',
    LICENSE_GRANT: 'License grant',
    USER_COMPLETE_AFTER_REDEMPTION: 'Complete user after redemption',
    PASSWORD_RESET_TRIGGER: 'Password reset',
    ACCESS_DIAGNOSE: 'Access diagnosis',
    REQUEST_MORE_INFO: 'Request more info',
    CLASSIFY_AND_ROUTE: 'Classify and route',
    CLOSE_AS_NOISE: 'Close as noise',
  },

  resolutions: {
    RESOLVED_UNIQUE: 'Unique match',
    RESOLVED_FUZZY: 'Fuzzy match',
    AMBIGUOUS: 'Ambiguous',
    NOT_FOUND: 'Not found',
    PICKED_BY_HUMAN: 'Picked by human',
    DNI_NAME_CONFLICT: 'DNI belongs to someone else',
  },

  target_status: {
    PENDING: 'Pending',
    APPLIED: 'Applied',
    FAILED: 'Failed',
    SKIPPED: 'Skipped',
  },

  // Possible `action.status` values other than PROPOSED (KB-907). An unknown
  // status falls back to the raw value — see `$te` in the card.
  action_status: {
    EXECUTED: 'Executed',
    EXECUTED_WITH_WARNING: 'Executed with warning',
    REJECTED: 'Rejected',
    FAILED: 'Failed',
  },

  // Field label for the business-language diff (KB-907). Mirrors
  // `ChangeField` in backend-v2.
  change_fields: {
    course: 'Course',
    campus: 'Campus',
    school: 'School',
    studentEmail: 'Student email',
    parentEmail: 'Parent email',
    firstName: 'First name',
    lastName: 'Last name',
    lastName2nd: 'Second last name',
    birthDate: 'Date of birth',
    dni: 'DNI',
    teacherCourses: 'Teacher courses',
  },

  counts: {
    empty: 'No actions in this lane',
    empty_for_type: 'No actions of type "{type}" in this lane.',
  },

  card: {
    ticket: 'Ticket #{id}',
    ticket_created_at: 'Ticket created on {date}',
    proposed_at: 'Action proposed on {date}',
    evidence_title: 'What the ticket says',
    view_full_ticket: 'View the full ticket',
    hide_full_ticket: 'Hide the full ticket',
    approval_note_title: 'Prior verification',
    diagnosis_title: 'Diagnosis result',
    manual_reason_title: 'Why it needs manual review',
    changes_title: 'What this action changes',
    changes_empty_value: '(empty)',
    payload_title: 'Action detail',
    targets_title: 'Students/teachers involved',
    view_profile: 'View profile',
    candidates_label: 'Pick among the candidates found',
    pick: 'Pick',
    pick_placeholder: 'Select a candidate',
    picked: 'Candidate picked',
    approve: 'Approve',
    approve_partial: 'Approve selected',
    approve_disabled_manual: 'This action needs manual review: it cannot be approved from here. Reject it if appropriate, or resolve the ticket by hand.',
    reject: 'Reject',
    no_eligible_targets: 'No student/teacher resolved yet: nothing to approve.',
    school_id: 'School #{id}',
    school: '{name}',
    reply_draft_title: 'Reply draft',
    save_draft: 'Save draft',
    execution_warning_title: 'What the post-execution check found',
    undo: 'Undo',
    undone_by: 'Undone by {by} on {date}',
  },

  batch: {
    select_all: 'Select all',
    approve_selected: 'Approve selected ({count})',
    result_success: '{count} action(s) approved',
    result_partial: '{success} approved, {failed} could not be approved',
  },

  errors: {
    load: 'Could not load actions. Please try again.',
    approve: 'Could not approve the action.',
    reject: 'Could not reject the action.',
    pick: 'Could not assign the picked candidate.',
    conflict: 'This action changed since it was loaded. The inbox was reloaded.',
    saveDraft: 'Could not save the draft. Please try again.',
    undo: 'Could not undo the action.',
  },

  success: {
    approved: 'Action approved',
    rejected: 'Action rejected',
    picked: 'Candidate assigned',
    draftSaved: 'Draft saved',
    undone: 'Action undone',
  },

  pagination: {
    per_page: 'Per page',
  },

  // Manual-lane tickets with no proposed action (KB-907). No approve/reject
  // buttons: these need to be handled by hand.
  unprocessed: {
    title: 'Tickets that could not be interpreted',
    empty: 'No unprocessed tickets in this lane.',
    reason_title: 'Why it could not be interpreted',
    ticket_date: 'Ticket created on {date}',
    form_data: 'Form: {name} — DNI {dni}',
  },
};
